import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import {
  PublishingData,
  PublishingPlatform,
  PublishingStepType,
} from '../models/publishing.model';

const PUBLISHING_URLS = {
  getPublicationStatus: (appId: number) =>
    `${environment.urls.MOBILE_API}/app/${appId}/publishing-status`,
  updateCompletedStep: (appId: number, platform: PublishingPlatform) =>
    `${environment.urls.MOBILE_API}/app/${appId}/${platform}/completed-step`,
};

@Injectable({
  providedIn: 'root',
})
export class PublishingService {
  constructor(private readonly http: HttpClient) {}

  getPublicationStatus(appId: number): Observable<PublishingData> {
    return this.http.get<PublishingData>(PUBLISHING_URLS.getPublicationStatus(appId));
  }

  updateCompletedStep(
    appId: number,
    platform: PublishingPlatform,
    step: PublishingStepType,
  ): Observable<void> {
    return this.http.put<void>(
      PUBLISHING_URLS.updateCompletedStep(appId, platform),
      null,
      {
        params: { step: step.toString() },
      },
    );
  }
}
